<!-- splash screen -->
<div
  #splashScreen
  class="m-splash-screen">
  <img
    [attr.src]="splashScreenImage"
    style="width: 90px; margin-bottom: 30px;"
    alt="Logo">
  <mat-spinner diameter="40"></mat-spinner>
</div>
<router-outlet></router-outlet>
<div
  class="loading-principal"
  style="display: none">
  <div class="container-mensagem-loading">
    <img src="./assets/demo/default/media/img/logo/logo-maxima.gif">
    <div class="mensagem-loading"></div>
  </div>
</div>

<rot-voltar-ao-topo>
</rot-voltar-ao-topo>
